import { registerTheme } from '../../theme';
var POINT_ACTIVE_STYLE = function (style) {
    var stroke = style.stroke || '#000';
    return {
        stroke: stroke,
    };
};
var POINT_SELECTED_STYLE = function (style) {
    var stroke = style.stroke || '#000';
    var lineWidth = style.lineWidth || 2;
    return {
        stroke: stroke,
        lineWidth: lineWidth,
    };
};
var POINT_INACTIVE_STYLE = function (style) {
    var fillOpacity = style.fillOpacity || style.opacity || 0.3;
    return {
        fillOpacity: fillOpacity,
    };
};
registerTheme('scatter', {
    pointStyle: {
        normal: {},
        active: POINT_ACTIVE_STYLE,
        selected: POINT_SELECTED_STYLE,
        inactive: POINT_INACTIVE_STYLE,
    },
});
//# sourceMappingURL=theme.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g2plot@1.1.24@@antv/g2plot/esm/plots/scatter/theme.js
// module id = null
// module chunks = 